// STYLES
import './_header.scss'

// LIBS
import React from 'react'

// COMPONENTS
import HeaderNavbar from '../header-navbar'

// INTERFACE
class Header extends React.Component {
  constructor (props) {
    super(props)
    // must use typeof operator to check for window so that gatsby wont crash during
    // serverside rendering (when window is an undefined var)
    if(typeof window === 'undefined'){
      this.state = {expanded: false}
    } else {
      this.state = {expanded: window.innerWidth > 1048}
    }
  }

  componentDidMount(){
    if(window){
      window.addEventListener('resize', (e) => {
        this.setState({expanded: window.innerWidth > 1048})
      })
    }
  }

  render () {
    return (
      <div id="header-container">
        <nav id="header" className="navbar navbar-default" role="navigation">
          <div className="container">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle"
                onClick={() => this.setState(state => ({ expanded: !state.expanded }))}
                >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <a href="/" className="navbar-brand">Code Fellows</a>
            </div>
            <div >
              {this.state.expanded ? <HeaderNavbar /> : undefined }
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js